export interface CellActionButton {
  icon?: string;
  text: string;
  tooltip?: string;
  clickEvent: (value: any) => void;
}
